import { useMemo } from 'react';
import { Restaurant } from '@restworld/utility-types';

export function useRwManagerInfo(restaurantDetails?: Restaurant) {
  const {
    organization: {
      assigned_to_rw_member: {
        name,
        surname,
        icon_url,
        user: { email, phone_number },
      },
    },
  } = restaurantDetails || { organization: { assigned_to_rw_member: { user: {} } } };

  const rwManagerInfo = useMemo(
    () => ({ name, surname, iconUrl: icon_url, email, phoneNumber: phone_number }),
    [email, icon_url, name, phone_number, surname]
  );

  return rwManagerInfo;
}
export default useRwManagerInfo;
